import { HeadingNode } from '@lexical/rich-text';
import {
  ParagraphNode,
  type Klass,
  type LexicalNode,
  type LexicalNodeReplacement,
} from 'lexical';

import { TemplateFieldNode } from './TemplateFieldNode';
import { TemplateHeadingNode } from './TemplateHeadingNode';
import { TemplateInstructionNode } from './TemplateInstructionNode';
import { TemplateParagraphNode } from './TemplateParagraphNode';

// Every heading and paragraph Lexical makes while the template is typed is
// a section's heading and a line.
export const TEMPLATE_EDITOR_NODES: (
  | Klass<LexicalNode>
  | LexicalNodeReplacement
)[] = [
  HeadingNode,
  {
    replace: HeadingNode,
    with: (node: HeadingNode) => new TemplateHeadingNode(node.getTag()),
    withKlass: TemplateHeadingNode,
  },
  TemplateHeadingNode,
  {
    replace: ParagraphNode,
    with: () => new TemplateParagraphNode(),
    withKlass: TemplateParagraphNode,
  },
  TemplateParagraphNode,
  TemplateFieldNode,
  TemplateInstructionNode,
];
